import React from 'react'
import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

import ContactDetailsColumn from 'components/crm/ContactDetailsColumn'

const StyledNewRightSidebar = styled('div')`
  flex-grow: 1;
  padding: ${themeVars.large};
  max-width: 100%;
  overflow: scroll;
  background: ${themeVars.brightSuperDark};
`

export default function NewRightSidebar() {
  return (
    <StyledNewRightSidebar className="NewRightSidebar">
      <ContactDetailsColumn />
    </StyledNewRightSidebar>
  )
}
